// Configuration de l'API pour Klasys
const API_CONFIG = {
  // ✅ URL relative - s'adapte automatiquement au domaine
  baseURL: '/api',
  
  // Timeout pour les requêtes (en millisecondes)
  timeout: 30000,
  
  // En-têtes par défaut
  headers: {
    'Content-Type': 'application/json',
  },
  
  // Configuration pour les credentials
  withCredentials: true,
  
  // Endpoints principaux
  endpoints: {
    auth: {
      login: '/auth/login',
      logout: '/auth/logout',
      refresh: '/auth/refresh-token',
      verify: '/auth/verify'
    },
    users: '/users',
    students: '/students',
    teachers: '/teachers',
    classes: '/classes',
    notifications: '/notifications',
    messages: '/messages'
  }
};

// Exports pour la compatibilité avec tous les imports existants
export const API_URL = API_CONFIG.baseURL;
export const API_BASE_URL = API_CONFIG.baseURL;
export const BASE_URL = API_CONFIG.baseURL;

// Configuration spécifique pour le système de messagerie hybride
export const MESSAGING_CONFIG = {
  // Intervalle de polling en millisecondes (30 secondes par défaut)
  pollingInterval: 30000,
  
  // Activer/désactiver le polling automatique
  enablePolling: true,
  
  // Nombre maximum de tentatives de reconnexion
  maxRetries: 3,
  
  // Délai entre les tentatives (en millisecondes)
  retryDelay: 5000
};

// Configuration pour les notifications
export const NOTIFICATION_CONFIG = {
  // Durée d'affichage des notifications (en millisecondes)
  displayDuration: 5000,
  
  // Position des notifications
  position: 'top-right',
  
  // Activer les notifications sonores
  enableSound: false,
  
  // Nombre maximum de notifications affichées simultanément
  maxNotifications: 5
};

export default API_CONFIG;